export const getLogicalOperator = () => {
  return [
    {
      label: "And",
      value: "AND",
    },
    {
      label: "OR",
      value: "OR",
    },
  ];
};

export const getColumnNames = () => {
  return [
    {
      label: "Email",
      value: "Emailid",
    },
    {
      label: "Company",
      value: "Companyname",
    },
    {
      label: "Pec Id",
      value: "Pecid",
    },
    {
      label: "Access Role(s)",
      value: "Accessroles",
    },
    {
      label: "Last Name",
      value: "Lastname",
    },
    {
      label: "First Name",
      value: "Firstname",
    },
    {
      label: "Country Code",
      value: "Countrycode",
    },
    {
      label: "Idp Name",
      value: "Idpname",
    },
    {
      label: "IDM Access Code",
      value: "Idmaccesscode",
    },
    {
      label: "Product Family",
      value: "Productfamily",
    },
    {
      label: "License Type",
      value: "Licensetype",
    },
    {
      label: "User Name",
      value: "Username",
    },
    {
      label: "EAR Restricted",
      value: "Earrestricted",
    },
    {
      label: "Is Enabled",
      value: "Isenabledstatus",
    },
    {
      label: "Created date",
      value: "Createddate",
    },
    {
      label: "Last update",
      value: "Modifieddate",
    },
    {
      label: "Last login date",
      value: "Logindatetime",
    },
    {
      label: "Migration Project",
      value: "Migrationproject",
    },
  ];
};

export const getAuditColumnNames = () => {
  return [
    {
      label: "Email",
      value: "emailid",
    },
    {
      label: "Access Role(s)",
      value: "comment",
    },
    {
      label: "Action",
      value: "action",
    },
    {
      label: "Fields",
      value: "fields",
    },
    {
      label: "Modified by",
      value: "updatedby",
    },
    {
      label: "Modified on",
      value: "auditdate",
    },
  ];
};

export const getOperators = () => {
  return [
    {
      label: "=",
      value: "=",
    },
    {
      label: "!=",
      value: "!=",
    },
    {
      label: ">",
      value: ">",
    },
    {
      label: ">=",
      value: ">=",
    },
    {
      label: "<",
      value: "<",
    },
    {
      label: "<=",
      value: "<=",
    },
    {
      label: "startswith",
      value: "startswith",
    },
    {
      label: "contains",
      value: "contains",
    },
    {
      label: "endswith",
      value: "endswith",
    },
  ];
};
